module.exports = __webpack_public_path__ + "img/mimg3.51c832b3.png";